import type { ColDef } from "ag-grid-enterprise";
import { ForecastMetaDataType } from "../../../../hooks/useFetchForecastMetaData";
import { ChangeFlashCell } from "../../cellRenderers/ChangeFlashCell";
import {
  createMetricValueParser,
  formatCellValueByMetric,
  getCellStyle
} from "../../utils/columnUtils";

export function createColumnsPinnedRight(
  metaData: ForecastMetaDataType
): ColDef[] {
  return [
    {
      field: "TTL",
      headerName: "Total",
      headerTooltip: "Total (aggregated)",
      cellRenderer: ChangeFlashCell,
      editable: false,
      // Read-only in every row, so it takes the read-only look throughout.
      cellStyle: (params) => getCellStyle(params, metaData),
      pinned: "right",
      type: "integer",
      valueParser: createMetricValueParser(metaData),
      valueFormatter: (params) => formatCellValueByMetric(params, metaData),
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agNumberColumnFilter",
            display: "accordion",
            filterParams: { buttons: ["apply", "reset"] }
          }
        ]
      }
    }
  ];
}
